export const setCellTextColor = (tableRef: any, cellName: string, color: string) => {
  tableRef.current?.jexcel.setStyle!(cellName, 'color', color)
}
